import UserApi from "@/api/user/UserApi";

const state = {
  accessToken: sessionStorage.getItem("UserAccessToken") || null,
  isLoggedIn: false,
  userStatus: 'USER',
  username: null,
  userId: null,
  itemData: JSON.parse(localStorage.getItem('itemData')) || null
};

const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token;
  },
  SET_LOGIN_STATUS(state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn;
  },
  setUserStatus(state, status) {
    state.userStatus = status;
  },
  setUsername(state, username) {
    state.username = username;
  },
  setUserId(state, userId) {
    state.useruserIdname = userId;
  },
};

const actions = {
  async login({ commit, dispatch }, { name, password }) {
    return UserApi.loginApi(name, password).then(data => {
      // console.log("data : ", data)
      sessionStorage.setItem("UserAccessToken", data.access_token);
      commit('setAccessToken', data.access_token);
      commit('SET_LOGIN_STATUS', true);

      localStorage.setItem('info', data.info);

      dispatch('userCheck');
      return data;
    }).catch(error => {
      console.error('Login error:', error);
      throw error;
    });
  },

  async logout({ commit }) {
    return UserApi.logoutApi().then(() => {
      sessionStorage.removeItem("UserAccessToken");
      commit('setAccessToken', null);
      commit('SET_LOGIN_STATUS', false);
      commit('setUsername', null);
      commit('setUserId', null);

      localStorage.removeItem('itemData');
      localStorage.removeItem('info');
    }).catch(error => {
      console.error('Logout error:', error);
      throw error;
    });
  },
  checkAuth({ commit, state }) {
    const token = sessionStorage.getItem("UserAccessToken");
    if (token) {
      if (!state.isLoggedIn) {
        commit('setAccessToken', token);
        commit('SET_LOGIN_STATUS', true);
      }
    } else if (state.isLoggedIn) {
      commit('setAccessToken', null);
      commit('SET_LOGIN_STATUS', false);
      commit('setUserStatus', 'guest');
      localStorage.removeItem('itemData');
      localStorage.removeItem('info');
    }
  },
  async userCheck({commit}){
    try {
      const response = await UserApi.usercheck();
      // console.log("response => ", response)
      commit('setUsername', response.username);
      commit('setUserId', response.userId);

      const filteredData = {
        userId: response.userId,
        // username: state.username,
      }

      // console.log("filteredData : ", filteredData)

      localStorage.setItem('itemData', JSON.stringify(filteredData));

      // console.log("userId 1 : ", JSON.parse(localStorage.getItem('itemData'))['userId'])

    } catch (error) {
      commit('setUserStatus', 'guest');
      commit('setAccessToken', null);
      commit('setUsername', null);
      commit('setUserId', null);

      localStorage.removeItem('itemData');
      localStorage.removeItem('info');
    }
  }
};

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userStatus: state => state.userStatus,
  userId: state => state.userId,
  username: state => state.username
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
